import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Warning = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 32, height: 32, fill: 'none', ...props.sx }}
    data-testid="warningIcon"
    titleAccess="error"
  >
    <g clipPath="url(#clip0_3269_23794)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0642 2.53179C14.863 0.934279 17.1427 0.934281 17.9414 2.53179L31.774 27.5302C32.4946 28.9714 31.4466 30.667 29.8354 30.667L2.17026 30.667C0.559025 30.667 -0.488926 28.9714 0.231642 27.5302L14.0642 2.53179ZM15.9999 25.867C16.9366 25.867 17.696 25.1076 17.696 24.1708C17.696 23.2341 16.9366 22.4747 15.9999 22.4747C15.0631 22.4747 14.3037 23.2341 14.3037 24.1708C14.3037 25.1076 15.0631 25.867 15.9999 25.867ZM14.3037 13.1631C14.3037 13.796 14.3092 19.8439 15.9999 19.8439C17.6905 19.8439 17.696 13.796 17.696 13.1631C17.696 12.2264 16.9366 11.467 15.9999 11.467C15.0631 11.467 14.3037 12.2264 14.3037 13.1631Z"
        fill="#D52B1E"
      />
    </g>
    <defs>
      <clipPath id="clip0_3269_23794">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Warning;
